// 学期api
import { baseRequest } from './base'

/**
 * @desc 查询首页信息
 */
function getSchoolInitData(params) {
  return baseRequest('/api/school/initData', 'get')
}

/**
 * @desc 查询首页通知列表
 */
function getAnnouncements(params) {
  return baseRequest('/api/school/getAnnouncements', 'get')
}

/**
 * @desc 查询课程列表
 */
function getSchoolCourse(params) {
  return baseRequest('/api/school/course', 'get', params)
}

/**
 * @desc 查询课程详情
 */
function getCourseDetail(params) {
  let tempUrl = '/api/school/courseDetail/' + params.id
  return baseRequest(tempUrl, 'get')
}

/**
 * @desc 查询家长端二维码
 */
function getQRCode(params) {
  return baseRequest('/api/school/getQRCode', 'get')
}

export default {
  getSchoolInitData,
  getAnnouncements,
  getSchoolCourse,
  getCourseDetail,
  getQRCode,
}
